import { ListHibernationSchedulesResponse } from '@cast/types-cluster-autoscaler';

export const clusterHibernationSchedulesListJson =
  (): ListHibernationSchedulesResponse => {
    return {
      items: [
        {
          id: 'f47ac10b-58cc-4372-a567-0e02b2c3d479',
          organizationId: '__ORG_ID__',
          enabled: true,
          name: 'Weekends',
          pauseConfig: {
            enabled: true,
            schedule: {
              cronExpression: 'CRON_TZ=Europe/Vilnius 0 0 * * sat',
            },
          },
          resumeConfig: {
            enabled: true,
            schedule: {
              cronExpression: 'CRON_TZ=Europe/Vilnius 0 0 * * mon',
            },
            jobConfig: {
              nodeConfig: {
                instanceType: 'm5.large',
                kubernetesLabels: {},
                kubernetesTaints: [],
              },
            },
          },
          clusterAssignments: {
            items: [
              {
                clusterId: '__CLUSTER_ID__',
              },
            ],
          },
          createTime: '__TIMESTAMP:-1d__',
          updateTime: '__TIMESTAMP:-1h__',
        },
        {
          id: '550e8400-e29b-41d4-a716-446655440000',
          organizationId: '__ORG_ID__',
          enabled: false,
          name: 'Weekdays nights',
          pauseConfig: {
            enabled: true,
            schedule: {
              cronExpression: 'CRON_TZ=Europe/Vilnius 0 23 * * 1-5',
            },
          },
          resumeConfig: {
            enabled: false,
            schedule: {
              cronExpression: 'CRON_TZ=Europe/Vilnius 0 6 * * 1-5',
            },
            jobConfig: {
              nodeConfig: {
                instanceType: 'm5.large',
                kubernetesLabels: {},
                kubernetesTaints: [],
              },
            },
          },
          clusterAssignments: {
            items: [
              {
                clusterId: '__CLUSTER_ID__',
              },
            ],
          },
          createTime: '__TIMESTAMP:-1d__',
          updateTime: '__TIMESTAMP:-1h__',
        },
        {
          id: 'b5c2d44d-5974-4c5b-b76e-e2b6ad187382',
          organizationId: '__ORG_ID__',
          enabled: false,
          name: 'Weekdays nights resume',
          pauseConfig: {
            enabled: false,
            schedule: {
              cronExpression: 'CRON_TZ=Europe/Vilnius 0 23 * * 1-5',
            },
          },
          resumeConfig: {
            enabled: true,
            schedule: {
              cronExpression: 'CRON_TZ=Europe/Vilnius 0 6 * * 1-5',
            },
            jobConfig: {
              nodeConfig: {
                instanceType: 'm5.large',
                kubernetesLabels: {},
                kubernetesTaints: [],
              },
            },
          },
          clusterAssignments: {
            items: [
              {
                clusterId: '__CLUSTER_ID__',
              },
            ],
          },
          createTime: '__TIMESTAMP:-2d__',
          updateTime: '__TIMESTAMP:-2h__',
        },
      ],
      nextPageCursor: '',
      totalCount: 3,
    };
  };
